import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { WizButtonModule } from '../controls/button/wiz-button.module';
import { WizBehaviorDirectiveModule } from './../../directives/behavior/wiz-behavior-directives.module';
import { WizStylingDirectiveModule } from './../../directives/styling/wiz-styling-directives.module';
import { WizImageModule } from './../controls/wiz-image/wiz-image.module';
import { WizLabelModule } from './../controls/wiz-label/wiz-label.module';
import { WizLayoutModule } from './../layouts/wiz-layout.module';
import { WizTabBar } from './wiz-tab-bar/wiz-tab-bar';
import { WizTabButton } from './wiz-tab-button/wiz-tab-button';

@NgModule({
  declarations: [WizTabBar, WizTabButton],
  imports: [
    CommonModule,
    MatIconModule,
    WizImageModule,
    WizLabelModule,
    WizLayoutModule,
    WizButtonModule,
    DragDropModule,
    WizStylingDirectiveModule,
    WizBehaviorDirectiveModule,
  ],
  exports: [WizTabBar, WizTabButton],
})
export class WizTabModule {}
